import { FaCaretDown } from "react-icons/fa";
import { LuHeading1, LuHeading2, LuHeading3, LuHeading4 } from "react-icons/lu";
import { useGetEditor } from "../../../context/useEditorContext";
import { useTheme } from "../../../context/useThemeContext";
import { IconsContainer } from "./IconsContainer";
import { Seperator } from "./Seperator";
import { TopButton } from "./TopButton";
import styled from "styled-components";

const HeaderBTNStyled = styled.div`
    &:hover {
        .header-dropdown {
            display: block !important;
        }
    }
`;

export function HeaderSelection() {
    const editor = useGetEditor().editor.current;
    const { theme } = useTheme();

    const headerIcons = [LuHeading1, LuHeading2, LuHeading3, LuHeading4];

    function getHeaderIcon() {
        for (let level = 1; level <= 4; level++) {
            if (editor?.isActive("heading", { level })) {
                const Icon = headerIcons[level - 1];
                return <Icon size={20} />;
            }
        }
        return <LuHeading1 size={20} />;
    }

    return (
        <IconsContainer>
            <HeaderBTNStyled
                className="headerSelection flex z-50"
                style={{
                    backgroundColor: theme.secondaryHeaderColor,
                }}
            >
                <TopButton
                    alt="Header selection"
                    isActive={editor?.isActive("heading")}
                    sizeX={36}
                    icon={
                        <div className="flex justify-center items-center">
                            {getHeaderIcon()}
                            <FaCaretDown size={10} />
                        </div>
                    }
                    onClick={() => {
                        if (editor?.isActive("heading")) {
                            editor.chain().focus().clearNodes().run();
                        } else {
                            editor
                                ?.chain()
                                .focus()
                                .toggleHeading({ level: 1 })
                                .run();
                        }
                    }}
                />

                <div
                    className="header-dropdown absolute rounded-b-md p-1"
                    style={{
                        backgroundColor: theme.secondaryHeaderColor,
                        top: "72px",
                        display: "none",
                    }}
                >
                    {headerIcons.map((Icon, index) => {
                        const level = index + 1;
                        return (
                            !editor?.isActive("heading", { level }) && (
                                <TopButton
                                    key={level}
                                    alt={`Heading ${level}`}
                                    isActive={editor?.isActive("heading", {
                                        level,
                                    })}
                                    icon={<Icon size={20} />}
                                    onClick={() =>
                                        editor
                                            ?.chain()
                                            .focus()
                                            .setHeading({
                                                level: (index + 1) as
                                                    | 1
                                                    | 2
                                                    | 3
                                                    | 4,
                                            })
                                            .run()
                                    }
                                />
                            )
                        );
                    })}
                </div>
            </HeaderBTNStyled>
            <Seperator />
        </IconsContainer>
    );
}
